<template lang="html">
  <b-container>
    <b-row>
      <b-col v-if="!$store.state.authorized" md="6">
        <h1>Login</h1>
        <Login />
      </b-col>
      <b-col v-if="$store.state.authorized" md="6">
        <h3>Update account info</h3>
        <div class="form-group">
          <label for="exampleInputEmail1">Email address</label>
          <input
            id="exampleInputEmail1"
            v-model="newEmailAddress"
            type="email"
            :disabled="updating"
            class="form-control"
            aria-describedby="emailHelp"
            placeholder="Enter new email"
          />
          <small id="emailHelp" class="form-text text-muted">
            You will need to verify your new email address.
          </small>

          <b-btn
            type="submit"
            size="sm"
            variant="primary"
            class="mt-2"
            @click="updateEmailAddress"
          >
            Update
          </b-btn>
        </div>
        <div v-if="errorMessage != ''" class="mt-3 alert alert-danger">
          {{ errorMessage }}
        </div>
      </b-col>
      <b-col v-if="$store.state.authorized" md="4">
        <p>
          <b-button variant="primary" @click="signOut()">Sign out</b-button>
        </p>
        <p>
          Logged in as <b>{{ $store.state.user.email }}</b>
        </p>
        <p v-if="$store.state.user.emailVerified">
          Your email address is verified.
        </p>
        <div v-else>
          <p>Your email address is not verified.</p>
          <b-btn size="sm" @click="$store.dispatch('sendEmailVerification')">
            Re-send verification email
          </b-btn>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import Login from "@/components/Login.vue";

export default {
  name: "Account",
  components: {
    Login
  },
  data() {
    return {
      newEmailAddress: "",
      updating: false,
      errorMessage: ""
    };
  },
  methods: {
    signOut() {
      this.$store.dispatch("sign_out");
    },
    updateEmailAddress() {
      this.updating = true;
      var _v = this;
      var user = this.$store.state.user;
      user
        .updateEmail(this.newEmailAddress)
        .then(function() {
          // Update successful.
          // Redirect to /account

          _v.$store.dispatch("toastMessage", {
            title: "Email changed",
            variant: "success",
            message: "Your email address was successfully updated."
          });
          _v.updating = false;
          _v.$router.push("/account");
          _v.$store.dispatch("sendEmailVerification");
        })
        .catch(function(error) {
          // An error happened.
          console.log(error);
          _v.updating = false;
          _v.errorMessage = error.message;
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
